:host {
  display: block;
}

span.hover-underline-text {
  @apply text-berry bg-no-repeat;
  background-image: linear-gradient(0deg, var(--vt-color-berry-default, #D7004B) 0%, var(--vt-color-berry-default, #D7004B) 100%);
  background-position: 100% 100.6%;
  background-size: 0% 1.5px;
  transition: background-size .2s ease-out 0s;
  transform: translateZ(0);
}

svg {
  @apply align-top inline relative leading-[1] w-[26px] sm:h-[30px] h-[29px] -left-[4px] sm:top-[7.25px] top-[4px] stroke-berry;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1px;
  stroke-dasharray: 13.2 22;
  stroke-dashoffset: 26;
  transition: stroke-dashoffset .3s cubic-bezier(0.3, 0.75, 0.5, 0.75) .1s;
}

div.hover-underline-overlay {
  @apply absolute w-[10px] h-[9px] right-[16px] bottom-[20px] bg-white;
  transition: bottom .5s ease-in;
}

a:hover, a[aria-hovered] {
  span.hover-underline-text {
    background-size: 100% 1.5px;
    transition: background-size .2s ease-out .1s;
  }

  div.hover-underline-overlay {
    transition: bottom .2s linear;
    bottom: 16px;
  }

  svg {
    stroke-dashoffset: 49;
    transition: stroke-dashoffset .3s linear 0s;
  }
}
